import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-maintenance-fuse',
  templateUrl: './maintenance-fuse.component.html',
  styleUrl: './maintenance-fuse.component.css',
})
export class MaintenanceFuseComponent { }
